import React, { memo } from 'react';
import type { ApplicationData } from '../types';

interface AdditionalRequestsSectionProps {
  application: ApplicationData;
  isEditing: boolean;
  editedData: Partial<ApplicationData>;
  onInputChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

const AdditionalRequestsSectionComponent: React.FC<AdditionalRequestsSectionProps> = ({
  application,
  isEditing,
  editedData,
  onInputChange
}) => {
  return (
    <div className="p-4 md:p-8">
      <h2 className="text-[#1e2c49] text-lg md:text-xl font-bold font-['Pretendard'] leading-9 mb-3 md:mb-4">
        추가 요청사항
      </h2>
      <div className="w-full md:w-[calc(100%-64px)] h-px outline outline-1 outline-offset-[-0.50px] outline-[#e5e8eb] mb-6 md:mb-8"></div>
      {isEditing ? (
        <textarea
          name="additionalRequest"
          value={editedData.additionalRequest || ''}
          onChange={onInputChange}
          rows={4}
          className="w-full h-28 md:h-36 bg-white rounded-sm outline outline-[0.50px] outline-gray-300 p-3 md:p-4 text-[#1e2c49] text-base md:text-[19px] font-semibold resize-none"
        />
      ) : (
        <p className="text-[#1e2c49] text-base md:text-[19px] font-semibold whitespace-pre-wrap break-all">
          {application.additionalRequest || '없음'}
        </p>
      )}
    </div>
  );
};

export const AdditionalRequestsSection = memo(AdditionalRequestsSectionComponent);
